import { Fragment } from 'react';
import EqualHeightComponent from '@bbkPricingPage/components/equal-height-component/equal-height-component';
import RenderAlignedHtml from './aligned-html-render';

export const PriceCardHeader = ({
  id,
  name,
  displayName,
  description,
  ignoreEqualHeight,
}: {
  id: string;
  name: string;
  displayName?: string;
  description?: string;
  ignoreEqualHeight: boolean;
}) => {
  return (
    <Fragment>
      <EqualHeightComponent
        groupId="dynamic-height-pricing-card-name"
        ignore={ignoreEqualHeight}
      >
        <h2
          id={`item-name-${id}`}
          className="tw-w-full tw-text-balance tw-text-center !tw-text-xl tw-font-bold tw-leading-6 tw-text-[var(--pricing-page-text-font-text-color)]"
          style={{ fontFamily: 'var(--pricing-page-font-family)' }}
        >
          {displayName ?? name}
        </h2>
      </EqualHeightComponent>
      <EqualHeightComponent
        groupId="dynamic-height-pricing-card-description"
        ignore={ignoreEqualHeight}
      >
        <div
          id={`item-description-${id}`}
          className="tw-text-balance tw-pt-0.5 tw-text-center tw-text-[color-mix(in_srgb,var(--pricing-page-text-font-text-color)_60%,transparent)] @sm:tw-text-sm [&_img]:tw-h-auto [&_img]:tw-max-w-full"
        >
          {description ? <RenderAlignedHtml value={description} /> : null}
        </div>
      </EqualHeightComponent>
    </Fragment>
  );
};
